/* application entry */
/* istanbul ignore next */
import "document-register-element";
import Vue from "vue";
import VueCustomElement from "vue-custom-element";
import VueSecureHTML from "vue-html-secure";
import VueRouter from "vue-router";

import App from "./App.vue";
import MwcApplicationHelper from "mwc-application-helper/src/mwc-application-helper";
import WebFont from "webfontloader";
import "./errorHandler";
import "./mds-fix.module.css";
import { loadAWSECoreFromCdn } from "./util";
import { setup, useCdnAsset } from "./microfrontend";
setup();
(async () => {
    await loadAWSECoreFromCdn();
    WebFont.load({
        custom: {
            /**
             * Univers Next Font: THIN,LIGHT,REGULAR,BOLD
             * n2:font-style:normal font-weight:$mds-font-weight-thin
             * n3:font-style:normal font-weight:$mds-font-weight-light
             * n4:font-style:normal font-weight:$mds-font-weight-regular
             * n6:font-style:normal font-weight:$mds-font-weight-bold
             */
            families: ["Univers:n2,n3,n4,n6"]
        }
    });

    Vue.prototype.$offByFunctionName = useCdnAsset("awse_core", "VuePrototypes").offByFunctionName;
    Vue.config.productionTip = false;

    Vue.use(VueRouter);
    Vue.use(VueCustomElement);
    Vue.use(VueSecureHTML);
    MwcApplicationHelper.initializeMwc();

    new Vue({
        render: h =>
            h(App, {
                props: {
                    mwcId: "mwc-hypo-app"
                }
            })
    }).$mount("#app");
})();
